//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _device from './device';
import _readerMode from './readerMode';
export const device = _device;
export const readerMode = _readerMode;
export default {device, readerMode};

